import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import { User } from '../user-selector/User'
import Icon, {IconType} from "../assets";

export const UserListItem = ({ user, onClick, customIcon} : { user: User, onClick: (user: User) => void , customIcon?: IconType}) =>
  <div class='list-item' onClick={() => onClick(user)}>
      {!customIcon && <UserAvatar disableLink disablePopup user={user} />}
      {customIcon && <Icon icon={customIcon} customClass={'list-item-custom-icon'}/>}
    <div>{user.name}</div>
  </div>

const UserList = ({ users, onClick }: { users: User[], onClick: (user: User) => void }) =>
  <div class='list'>
    { users.map((user: User) => <UserListItem user={user} onClick={onClick} />) }
  </div>

export default UserList
